exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tabs a[data-v-f554d3be] {\n  background: #d9e0e0;\n  color: black;\n  border-radius: 5px;\n  padding: 3px 25px 3px 25px;\n}\n#tabs a.active[data-v-f554d3be],\n#tabs a.preactive[data-v-f554d3be] {\n  background: #38b1af !important;\n  color: white !important;\n  border-radius: 5px !important;\n  padding: 3px 25px 3px 25px !important;\n}\n", ""]);

// exports
